import { Link } from "react-router-dom";
import logo from "../../assets/images/blue_logo.png";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Profile from "./Header/components/Profile";
import { LoginOutlined } from "@ant-design/icons";

export default function ChanHeader() {
  const { token } = useContext(AuthContext);
  const [isVisible, setVisible] = useState(false);

  return (
    <div className="h-14 bg-white flex flex-row justify-between items-center px-5">
      <div className="flex flex-row items-center  ">
        <Link
          to="/"
          className="flex justify-center items-center border-gray-400 pr-4"
        >
          <img src={logo} alt="Logo" height={15} width={150} />
        </Link>
      </div>
      <div className="flex flex-row items-center">
        {token ? (
          <div className="z-50">
            <Profile isVisible={isVisible} setVisible={setVisible} />
          </div>
        ) : (
          <Link
            to={"/"}
            className="mx-4 flex justify-center items-center text-white rounded-md py-1"
          >
            <LoginOutlined color="#FFFFFF" size={22} />
          </Link>
        )}
      </div>
    </div>
  );
}
